import _styled from "styled-components";
const _excluded = ["style", "className", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';

/**
 * List of routes rendered within the SideNavigation component.
 */

const SideNavigationList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledUl, _extends({}, props, {
    "data-testid": "SideNavigationList",
    className: className,
    ref: ref,
    $_css: [{
      listStyle: 'none',
      overflowY: 'auto',
      overflowX: 'hidden',
      margin: 0,
      padding: 0
    }, style]
  }), children);
});
SideNavigationList.displayName = 'SideNavigationList';
SideNavigationList.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** children of SideNavigationList */
  children: PropTypes.node
};
export default SideNavigationList;
var _StyledUl = _styled("ul").withConfig({
  displayName: "SideNavigationList___StyledUl",
  componentId: "sc-m11gsx-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=SideNavigationList.js.map